import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react'

import {
  Dialog, DialogProps, DialogContent, DialogContentProps,
  Box, Alert, Slide
} from '@mui/material'

import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'

import { DialogCaption } from './components/caption'
import { DialogAction, DialogActionProps } from './components/action'

type DialogBaseProps = {
  isLoading?: boolean
  percent?: number
  title?: string
  titleElement?: ReactElement
  note?: ReactElement
  notice?: string | null
  body: ReactNode
  contentProps?: DialogContentProps
  error?: Error | Error[] | null
  action?: DialogActionProps
  children?: ReactNode
  onClose: () => void
  onBack?: () => void
} & DialogProps

export const DialogBase = ({
  isLoading,
  percent,
  title,
  titleElement,
  note,
  notice,
  body,
  contentProps,
  error,
  onClose,
  onBack,
  action,
  children,
  ...others
}: DialogBaseProps) => {
  const [openNotice, setOpenNotice] = useState<boolean>(false)
  const noticeCloseTimer = useRef<NodeJS.Timeout | null>(null)
  useEffect(
    () => {
      if (noticeCloseTimer.current) clearTimeout(noticeCloseTimer.current)
      setOpenNotice(notice ? true : false)
      if (notice) {
        noticeCloseTimer.current = setTimeout(() => {
          setOpenNotice(false)
          noticeCloseTimer.current = null;
        }, 3000)
      }
    },
    [notice, setOpenNotice]
  )
  return (
    <Dialog
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return
        onClose()
      }}
      {...others}
    >
      {isLoading && <Loading percent={percent}/>}
      {titleElement ? titleElement : <DialogCaption title={title} onBack={onBack} onClose={onClose} />}
      {note}

      <DialogContent sx={{ paddingTop: "12px" }} {...contentProps}>
        {body}
        <ErrorBlock error={error} marginTop={1}/>
      </DialogContent>

      <Box flexGrow={1} overflow='hidden'>
        <Slide
          in={openNotice}
          mountOnEnter unmountOnExit
          direction="up"
        >
          <Alert severity="success" onClose={() => setOpenNotice(false)}>{notice}</Alert>
        </Slide>
      </Box>

      <DialogAction {...action}/>

      {children}

    </Dialog>
  )
}
